import styled, { css } from 'styled-components';
import { ListItem } from '@material-ui/core';

export const MuiListItem = styled(ListItem)<{
  borderColor?: string;
}>`
  ${({ borderColor }) => css`
    border-left: 0.3rem solid ${borderColor ?? 'transparent'};
    padding: 0.2rem 1.5rem;
  `}
`;
